import React from 'react';

const NotFoundPage = () => (
  <div className="container has-text-centered">
    <span className="is-size-1">404</span>
  </div>
);

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/js/components/NotFoundPage.js